<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopAccountDetailManage.queryConditions') }}</div>
        <div class="ibox-tools" style="top:10px;"></div>
      </div>
      <div class="">
        <el-form :inline="true" :model="shopAccountDetailManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-select 
              v-model="shopAccountDetailManageInfo.conditions.acctId" 
              :placeholder="$t('shopAccountDetailManage.selectAccount')"
              style="width:100%"
            >
              <el-option 
                v-for="(item,index) in shopAccountDetailManageInfo.shopAccounts"
                :key="index"
                :label="item.acctName + item.acctTypeName"
                :value="item.acctId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select 
              v-model="shopAccountDetailManageInfo.conditions.detailType" 
              :placeholder="$t('shopAccountDetailManage.selectDetailType')"
              style="width:100%"
            >
              <el-option 
                v-for="(item,index) in shopAccountDetailManageInfo.detailTypes"
                :key="index"
                :label="item.name"
                :value="item.statusCd"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input 
              v-model="shopAccountDetailManageInfo.conditions.orderId" 
              :placeholder="$t('shopAccountDetailManage.inputOrderId')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryshopAccountDetailMethod()">
              <i class="el-icon-search"></i> {{ $t('shopAccountDetailManage.query') }}
            </el-button>
            <el-button type="primary" @click="_resetshopAccountDetailMethod()">
              <i class="el-icon-refresh"></i> {{ $t('shopAccountDetailManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopAccountDetailManage.financialDetails') }}</div>
        <div class="ibox-tools" style="top:10px;"></div>
      </div>
      <div class="">
        <el-table 
          :data="shopAccountDetailManageInfo.shopAccountDetails" 
          border 
          style="width:100%"
        >
          <el-table-column prop="detailId" :label="$t('shopAccountDetailManage.detailId')" align="center"></el-table-column>
          <el-table-column prop="orderId" :label="$t('shopAccountDetailManage.orderId')" align="center"></el-table-column>
          <el-table-column prop="acctName" :label="$t('shopAccountDetailManage.accountName')" align="center"></el-table-column>
          <el-table-column prop="detailType" :label="$t('shopAccountDetailManage.detailType')" align="center">
            <template slot-scope="scope">
              {{ scope.row.detailType == '1001' ? $t('shopAccountDetailManage.transferIn') : $t('shopAccountDetailManage.transferOut') }}
            </template>
          </el-table-column>
          <el-table-column prop="amount" :label="$t('shopAccountDetailManage.amount')" align="center"></el-table-column>
          <el-table-column prop="createTime" :label="$t('shopAccountDetailManage.transactionTime')" align="center"></el-table-column>
          <el-table-column prop="remark" :label="$t('shopAccountDetailManage.remark')" align="center"></el-table-column>
        </el-table>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="shopAccountDetailManageInfo.conditions.page"
          :page-size="shopAccountDetailManageInfo.conditions.row"
          layout="total, prev, pager, next"
          :total="shopAccountDetailManageInfo.total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryAccountDetail, queryAccount } from '@/api/goods/shopAccountDetailManage/shopAccountDetailManageApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopAccountDetailManage',
  data() {
    return {
      shopAccountDetailManageInfo: {
        shopAccountDetails: [],
        shopAccounts: [],
        total: 0,
        records: 1,
        moreCondition: false,
        scId: '',
        detailTypes: [],
        conditions: {
          acctId: '',
          detailType: '',
          orderId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      this.shopAccountDetailManageInfo.scId = getShopId()
      console.log(this.shopAccountDetailManageInfo.moreCondition)
      await this._loadShopAccounts()
      await this._listshopAccountDetails(1, 10)
      await this._loadDictData()
    },
    async _loadDictData() {
      try {
        const {data} = await getDict('account_detail', 'detail_type')
        this.shopAccountDetailManageInfo.detailTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listshopAccountDetails(page, rows) {
      this.shopAccountDetailManageInfo.conditions.page = page
      this.shopAccountDetailManageInfo.conditions.row = rows
      try {
        const res = await queryAccountDetail(this.shopAccountDetailManageInfo.conditions)
        this.shopAccountDetailManageInfo.total = res.total
        this.shopAccountDetailManageInfo.records = res.records
        this.shopAccountDetailManageInfo.shopAccountDetails = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryshopAccountDetailMethod() {
      this._listshopAccountDetails(1, this.shopAccountDetailManageInfo.conditions.row)
    },
    _resetshopAccountDetailMethod() {
      this.shopAccountDetailManageInfo.conditions = {
        acctId: '',
        detailType: '',
        orderId: '',
        page: 1,
        row: 10
      }
      this._listshopAccountDetails(1, 10)
    },
    handleCurrentChange(val) {
      this._listshopAccountDetails(val, this.shopAccountDetailManageInfo.conditions.row)
    },
    async _loadShopAccounts() {
      try {
        const res = await queryAccount({
          page: 1,
          row: 50
        })
        this.shopAccountDetailManageInfo.shopAccounts = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0,0,0,.05);
}
.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  clear: both;
  padding: 15px;
}
</style>